'use strict';

bbw.model.BlogPost = bbw.model.AbstractPostManager.extend({

    _getPostTypeName: function() {
        return 'blog';
    }

});
